<ion-app id="ionApp" dir="{{ textDir }}">
  <!-- when=false means that the split pane will never expand automatically -->
  <!-- For more info check https://ionicframework.com/docs/api/split-pane -->
  <ion-split-pane id="splitPane" contentId="menu-content" when="false">
    <ion-menu contentId="menu-content" class="app-sidemenu">
      <ion-toolbar class="">
        <ion-row>
          <img
            class="inner-img"
            style="padding: 2em 2em 2em 2em; height: auto"
            [src]="'../../assets/logo.png'"
          />
        </ion-row>
        <ion-row class="user-details-wrapper" *ngIf="g.profile">
          <!-- <ion-col size="4">
              <app-aspect-ratio [ratio]="{w: 1, h: 1}">
                <img class="inner-img" [src]="'./assets/sample-images/ionicthemes_logo.jpg'" />
              </app-aspect-ratio>
            </ion-col> -->

          <ion-col class="user-info-wrapper">
            <!-- <h3 class="user-name">TET Alliance</h3> -->
            <h5 class="user-handle">Welcome, {{ g.profile.name }}</h5>
          </ion-col>
          <ion-col size="0.5" style="margin-right: 20px">
            <span class="user-stat-name" (click)="logout()"
              ><ion-icon name="log-out-outline"></ion-icon
            ></span>
          </ion-col>
        </ion-row>
        <ion-row class="user-stats-wrapper user-details-wrapper">
          <!-- <ion-col>
              <span class="user-stat-value">Profile</span>
              <span class="user-stat-name">Following</span>
            </ion-col> -->
        </ion-row>
      </ion-toolbar>
      <ion-content>
        <ion-list>
          <ng-container *ngIf="m.configPages.length > 0">
            <ion-list-header>
              <ion-label>Configuration</ion-label>
            </ion-list-header>
            <ion-menu-toggle
              autoHide="false"
              *ngFor="let p of m.configPages; let i = index"
            >
              <ion-item
                routerDirection="root"
                [routerLink]="p.url"
                routerLinkActive="active-item"
              >
                <ion-icon
                  slot="start"
                  [name]="p.icon ? p.icon : ''"
                  [src]="p.customIcon ? p.customIcon : ''"
                ></ion-icon>
                <ion-label>
                  {{ p.title }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ng-container>
          <ng-container *ngIf="m.adminPages.length > 0">
            <ion-list-header>
              <ion-label>Admin</ion-label>
            </ion-list-header>
            <ion-menu-toggle
              autoHide="false"
              *ngFor="let p of m.adminPages; let i = index"
            >
              <ion-item
                routerDirection="root"
                [routerLink]="p.url"
                routerLinkActive="active-item"
              >
                <ion-icon
                  slot="start"
                  [name]="p.icon ? p.icon : ''"
                  [src]="p.customIcon ? p.customIcon : ''"
                ></ion-icon>
                <ion-label>
                  {{ p.title }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ng-container>
          <ng-container *ngIf="m.employeePages.length > 0">
            <ion-list-header>
              <ion-label>Employee</ion-label>
            </ion-list-header>

            <ion-menu-toggle
              autoHide="false"
              *ngFor="let p of m.employeePages; let i = index"
            >
              <ion-item
                routerDirection="root"
                [routerLink]="p.url"
                routerLinkActive="active-item"
              >
                <ion-icon
                  slot="start"
                  [name]="p.icon ? p.icon : ''"
                  [src]="p.customIcon ? p.customIcon : ''"
                ></ion-icon>
                <ion-label>
                  {{ p.title }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ng-container>
        </ion-list>
      </ion-content>
    </ion-menu>
    <!-- Main app content get's rendered in this router-outlet -->
    <ion-router-outlet id="menu-content"></ion-router-outlet>
    <div class="central-loader" *ngIf="g.loadingJwt">
      <div><i class="fa fa-spin fa-spinner"></i>&nbsp; Loading...</div>
    </div>
  </ion-split-pane>
  <div [style]="this.g.topHeader" id="cameraScreen" class="hideDisplay">
    <div style="margin-left: 15px">
      <ion-icon
        style="font-size: 3em"
        color="light"
        name="arrow-back-circle"
        (click)="stopCamera()"
      ></ion-icon>
    </div>
  </div>
  <app-loader></app-loader>
</ion-app>
